<template>
  <div class="userCenter">
    <job-header-simple header_title="基本信息"></job-header-simple>
    <div class="card_box">
      <div class="card_header van-hairline--bottom">个人信息</div>
      <div class="card_content">
        <div class="baseInfo">
          <van-cell class="item item_head" title="头像">
            <van-image
              width="30px"
              height="30px"
              round
              fit="cover"
              :src="mobileDefaultAvatar?mobileDefaultAvatar:(userInfoData&&userInfoData.headshot)?userInfoData.headshot:require('@/assets/img_default.png')"
            />
          </van-cell>
          <van-cell class="item" title="姓名" :value="userInfoData.name"></van-cell>
          <van-cell
            class="item"
            title="手机号码"
            :value="userInfoData.mobile"
            is-link
            @click="resetTel"
          ></van-cell>
          <template v-for="item in papersTypeOptions">
            <van-cell
              class="item"
              title="证件类型"
              v-if="userInfoData.papersType == item.code"
              :value="item.value"
              :key="item.id"
            ></van-cell>
          </template>
          <van-cell
            class="item"
            title="证件号码"
            :value="userInfoData.idNumber|desensitization"
          ></van-cell>
          <van-cell  class="item" title="证件照片">
          <template v-if="userInfoData.papersType=='1'">
            <span v-if="userInfoData.front!=null&&userInfoData.front!='undefined'&&userInfoData.front!=''
            &&userInfoData.back!=null&&userInfoData.back!='undefined'&&userInfoData.back!=''" @click="uploadIdCard">查看证件</span>
            <span v-if="userInfoData.front==null||userInfoData.front=='undefined'||userInfoData.front==''
            ||userInfoData.back==null||userInfoData.back=='undefined'||userInfoData.back==''" @click="uploadIdCard">上传证件</span>
          </template>
          <template v-if="userInfoData.papersType!='1'">
            <span v-if="userInfoData.front!=null&&userInfoData.front!='undefined'&&userInfoData.front!=null" @click="uploadIdCard">查看证件</span>
            <span v-if="userInfoData.front==null||userInfoData.front=='undefined'||userInfoData.front==null" @click="uploadIdCard">上传证件</span>
          </template>
          </van-cell>

          <van-cell class="item" title="认证状态">
            <span
              v-if="userInfoData.certificationStatus == 'UNVERIFIED'"
              >未认证</span
            >
            <span
              class="text_red"
              v-if="userInfoData.certificationStatus == 'AUTHENTICATION_FAILURE'"
              >认证失败</span
            >
            <span v-if="userInfoData.certificationStatus == 'AUTHENTICATIONOK'"
              >已认证</span
            >
          </van-cell>
          <van-cell class="item" title="接单意向" is-link @click="editResume">
            <span
              class="text_theme"
              v-if="userInfoData.jobMemo == null || userInfoData.jobMemo == ''"
              >添加</span
            >
            <span
              class="text_theme"
              v-if="userInfoData.jobMemo != null && userInfoData.jobMemo != ''"
              >查看</span
            >
          </van-cell>
          <van-cell class="item" title="隐私政策" is-link @click="toPrivacy"></van-cell>
        </div>
      </div>
    </div>

    <div class="card_box">
      <div class="card_header van-hairline--bottom">公司信息</div>
      <div class="card_content">
        <section class="company">
          <div class="item">
            <label>所属公司</label>
            <div class="value">
              <template v-if="outsourcing_company.length">
                <p
                  v-for="item in outsourcing_company"
                  :key="item"
                  class="van-hairline--bottom"
                >
                  {{ item }}
                </p>
              </template>
              <template v-else>
                <p>无</p>
              </template>
            </div>
          </div>
          <div class="item">
            <label>外派公司</label>
            <div class="value">
              <template v-if="expatriate_company.length">
                <div
                  class="line van-hairline--bottom"
                  v-for="item in expatriate_company"
                  :key="item.ecompanyName"
                >
                  <span
                    class="icon_status tobe"
                    v-if="item.status == 'wsign'"
                    @click="toContractList"
                    >待签署</span
                  >
                  <span
                    class="icon_status yes"
                    v-else-if="item.status == 'signed'"
                    @click="toContractList"
                    >已签署</span
                  >
                  <span
                    class="icon_status end"
                    v-else-if="item.status == 'termination'"
                    @click="toContractList"
                    >已终止</span
                  >
                  <span
                    class="icon_status yes"
                    v-else-if="item.status == 'unifiedSignSuccess'"
                    @click="toContractList"
                    >企业统签</span
                  >
                  <span class="icon_status no" v-else @click="toContractList"
                    >未签署</span
                  >
                  <p>{{ item.ecompanyName }}</p>
                </div>
              </template>
              <p v-else>无</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { Image, Cell, CellGroup, Button, Icon } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    jobHeaderSimple,
  },
  data() {
    return {
      papersTypeOptions: [],
      user: {},
      outsourcing_company: [],
      expatriate_company: [],
      userInfoData:{},//用户信息
    };
  },
  computed: {
    ...mapGetters(["userInfo","mobileDefaultAvatar"]),
  },
async  created() {
  this.userInfoData =  await this.getActiveUserAllInfoInit();
    this.getPaperType();
    this.initCompanyInfos();
  },
  methods: {
    getActiveUserAllInfoInit(){
      return new Promise((resolve, reject) => {
        if(this.userInfo&&this.userInfo.id){
             resolve(this.userInfo);
        }else{ 
            if (getToken()) { 
                api.getActiveUserAllInfo().then((res) => {
                    if (res.data.status == "200") {
                    let user = res.data.data;
                      this.$store.commit('SET_USER_INFO', user)
                    resolve(user);
                    }
                }).catch(error => {
                    reject(error);
                });
            } else{
                resolve("");
            }
        }
  
      })
    },
    //证件照片相关方法
    uploadIdCard(){
      let that=this;
      let frontUrl="";
      let backUrl="";
      if (that.userInfoData.front!=null&&that.userInfoData.front!=''&&that.userInfoData.front!=undefined){
        frontUrl=process.env.VUE_APP_FILE_PATH + that.userInfoData.front;
      }
      if (that.userInfoData.back!=null&&that.userInfoData.back!=''&&that.userInfoData.back!=undefined){
        backUrl=process.env.VUE_APP_FILE_PATH + that.userInfoData.back;
      }
      this.$router.push({path:"editPapers",query:{
          papersType:that.userInfoData.papersType,
          username:that.userInfoData.username,
          frontUrl:frontUrl,
          backUrl:backUrl,
        }})
    },



    getPaperType() {
      api.getDataDictList({ group: "papersType" }).then((response) => {
        this.papersTypeOptions = response.data.data;
      });
    },
    toContractList() {
      this.$router.push({ path: "/contractList" });
    },
    resetTel() {
      this.$router.push({
        path: "/resetTel",
      });
    },

    editResume() {
      this.$router.push({
        path: "/editResume",
      });
    },
    initCompanyInfos() {
      api.getEOCompany().then((res) => {
        if (res.data.status == "200") {
          this.outsourcing_company = res.data.data.ocompany;
          this.expatriate_company = res.data.data.ecompany;
        }
      });
    },
    toPrivacy(){
      this.$router.push({
        path: "/privacy",
      })
    }
  },
  filters:{
    desensitization:value=>{
      if(value&&value!==""){
        return `${value.substring(0,4)}****${value.substring(14,18)}`
      }
    }
  }
};
</script>

<style lang="less" scoped>
.userCenter {
  .card_box {
    margin: 8px 12px;
    background: #fff;
    border-radius: 6px;
    .card_header {
      font-size: 14px;
      padding: 14px;
      font-weight: 600;
    }

    .card_content {
      padding-bottom: 10px;
      .baseInfo {
        .item {
          color: #333;
          &.item_head {
            line-height: 0;
            /deep/ .van-cell__title {
              line-height: 30px;
            }
          }

          .van-icon-arrow {
            color: #ddd;
          }

          .van-cell__value {
            color: #333;
          }
          .van-cell__right-icon {
            margin-left: 0;
          }
        }
      }
    }
  }

  .text_theme {
    color: #6c7ef3;
  }

  .text_red {
    color: #f44;
  }
}

.company {
  background: #fff;
  padding: 6px 16px;
  line-height: 20px;
  .item {
    position: relative;
    overflow: hidden;
    font-size: 13px;
    margin-bottom: 6px;
    label {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 70px;

      padding: 6px 0;
    }
    .value {
      display: block;
      .line {
        overflow: hidden;
        p {
          width: 50%;
        }
      }
      p {
        padding: 6px 10px 6px 70px;
      }

      .icon_status {
        font-size: 0.24rem;
        color: #fff;
        padding: 0 0.1333rem;
        border-radius: 0.32rem;
        margin-left: 6px;
        margin-top: 6px;
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        &.yes {
          background-color: #8493fa;
        }
        &.no {
          background-color: #bbbbbb;
        }
        &.tobe {
          background-color: #f3a871;
        }
        &.end {
          background-color: #f38c6c;
        }
      }
    }
  }
}
</style>
